import toArray from "lodash/toArray";
import { titleCase } from "./filters/string";
import { useStore } from "./vuex-shim";
let baseUrl;
let isMetaKey = false;
window.addEventListener('keydown', e => {
    isMetaKey = e.metaKey;
});
window.addEventListener('keyup', e => {
    isMetaKey = false;
});
const setUtilsBaseUrl = (url) => {
    baseUrl = url;
};
const openInNewTab = (uri, parameters = [], queryParameters = {}, raw = false) => {
    let location = uri;
    if (!raw) {
        location = buildUrl(uri, parameters, queryParameters);
    }
    else {
        location = uri + buildQueryString(queryParameters);
    }
    return window.open(location, '_blank');
};
const buildQueryString = (queryParameters = {}) => {
    for (let i in queryParameters) {
        queryParameters[i] = (encodeURIComponent(i) + '=' + encodeURIComponent(queryParameters[i]));
    }
    let queryString = '';
    if (toArray(queryParameters).length > 0) {
        queryString = '?' + toArray(queryParameters).join('&');
    }
    return queryString;
};
const buildUrl = (uri, parameters = [], queryParameters = {}) => {
    if (parameters.length > 0) {
        let i = 0;
        uri = uri.replace(/%s/g, function () {
            let replacement = parameters[i];
            i++;
            return replacement;
        });
    }
    return baseUrl + '/' + uri + buildQueryString(queryParameters);
};
const printElement = (el, header = '') => {
    let w = document.createElement('iframe');
    w.style.position = 'fixed';
    w.style.zIndex = '-1000';
    document.body.appendChild(w);
    const e = el.cloneNode(true);
    const all = e.getElementsByTagName('*');
    for (let i in all) {
        if (all[i] instanceof HTMLElement) {
            all[i].removeAttribute('style');
        }
    }
    if (e.tagName.toUpperCase() === 'HTML') {
        w.contentWindow?.document.documentElement.replaceWith(e);
    }
    else {
        w.contentWindow?.document.write("<!DOCTYPE html><html><head><style>html, body { font-family: sans-serif; }</style></head><body>");
        if (header) {
            w.contentWindow?.document.write(header);
        }
        w.contentWindow?.document.write("<div id='target'></div>");
        w.contentWindow?.document.write("</div>");
        w.contentWindow?.document.write("</body></html>");
        const icon = e.querySelector('.material-icons');
        if (icon) {
            e.querySelector('.material-icons')?.parentNode?.removeChild(icon);
        }
        w.contentWindow?.document.querySelector('#target')?.replaceWith(e);
    }
    w.contentWindow?.print();
    setTimeout(() => {
        document.body.removeChild(w);
    }, 500);
};
const reload = () => {
    window.location.reload();
};
const goTo = (uri, newWindow = false) => {
    if (!isMetaKey && !newWindow) {
        window.location.assign(uri);
        return;
    }
    window.open(uri, '_blank');
};
const navigateTo = (uri, parameters = [], queryParameters = {}) => {
    goTo(buildUrl(uri, parameters, queryParameters));
};
const getQueryVariable = (variable) => {
    const query = window.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return;
};
const routeIs = (pattern) => {
    let path = window.location.pathname;
    return !!path.match(pattern);
};
const printElementViaCanvas = (el) => {
    return new Promise((resolve, reject) => {
        import("html2canvas" /* webpackChunkName: "html2canvas" */).then(({ default: html2canvas }) => {
            html2canvas(el).then(canvas => {
                let img = document.createElement('img');
                img.setAttribute('src', canvas.toDataURL());
                img.style.maxWidth = '100%';
                setTimeout(() => {
                    printElement(img);
                }, 250);
                setTimeout(() => {
                    resolve();
                }, 500);
            });
        });
    });
};
const userCan = (permission) => {
    return useStore().getters['user/can'](permission);
};
// Figure cloaking hides certain financial information from unprivileged users, whereas job
// cloaking hides the vehicles job area.
// A configuration key is present under the 'tweaks' section of the backend account
// configuration file. Backed by FigureCloakingStatusProvider::class.
const figureCloakingIsNotActive = () => {
    // @ts-ignore
    return !window.marque.ui.authorisations.figure_cloaking_active;
};
const figureCloakingIsActive = () => {
    return !figureCloakingIsNotActive();
};
const jobCloakingIsNotActive = () => {
    // @ts-ignore
    return !window.marque.ui.authorisations.job_cloaking_active;
};
const jobCloakingIsActive = () => {
    return !jobCloakingIsNotActive();
};
const shouldShowFundingMarkers = () => {
    return (!window.marque.ui.tweaks.restrict_funding_markers ||
        window.marque.ui.tweaks.restrict_funding_markers && window.marque.ui.authorisations['manage_funding.accounts']);
};
const shouldShowInvoiceNotes = () => {
    return !!window.marque.ui.tweaks.invoice_notes;
};
const reportApiError = function (error, reject = null) {
    if (reject === null || reject(error) !== true) {
        let handled = false;
        // Handle validation errors.
        if (error.response && error.response.status === 422) {
            let message = '';
            if (error.response.data && error.response.data.constructor.name === 'ArrayBuffer') {
                const blob = new Blob([error.response.data], { type: 'application/json' });
                blob.text().then(text => {
                    if (error.response) {
                        error.response.data = JSON.parse(text);
                        reportApiError(error);
                    }
                });
                return;
            }
            // Handle product errors.
            if (error.response.data && error.response.data.products) {
                for (let i in error.response.data.products) {
                    message += i + "\r\n";
                    for (let c in error.response.data.products[i]) {
                        message += c + ": " + error.response.data.products[i][c][0] + "\r\n";
                    }
                }
            }
            // Handle BusinessLogicException format.
            else if (error.response.data && error.response.data.errors && error.response.data.errors['action']) {
                message = error.response.data.message;
            }
            else {
                message = "You may have entered something incorrectly, please check the form fields and try again.\n\nFields with possible errors are:";
                for (let k in error.response.data.errors) {
                    message += "\n- " + k.replace('_', ' ') + ": " + error.response.data.errors[k].join(" / ");
                }
            }
            alert(message);
            handled = true;
        }
        else if (error.response && error.response.status === 403) {
            alert('Sorry! You can\'t do that.');
            handled = true;
        }
        else if (error.response && error.response.status === 401) {
            // @ts-ignore
            if (window.marque.ui.app) {
                // @ts-ignore
                window.marque.ui.app.$emit('unauthenticated');
                handled = true;
            }
        }
        if (!handled) {
            if (error.response) {
                if (typeof window.Sentry === 'object' &&
                    error.response.headers['x-sentry-event-id'] &&
                    '' !== error.response.headers['x-sentry-event-id'].trim()) {
                    console.info('Sentry Event ID: ', error.response.headers['x-sentry-event-id']);
                    window.Sentry.showReportDialog({
                        eventId: error.response.headers['x-sentry-event-id'],
                        dsn: window.marque.ui.sentryDSN,
                        user: {
                            'id': window.marque.ui.user.id,
                            'name': window.marque.ui.user.name,
                            'email': window.marque.ui.user.email,
                        }
                    });
                }
                else if (error.response) {
                    console.error(error);
                    console.log(error.response);
                    if (error.response.data && error.response.data.message) {
                        alert(error.response.data.message);
                    }
                }
            }
        }
    }
    window.marque.ui.lastSentryEventID = null;
};
const fileDownload = (data, fileName, type = "text/plain") => {
    // Create an invisible A element
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);
    // Set the HREF to a Blob representation of the data to be downloaded
    a.href = window.URL.createObjectURL(new Blob([data], { type }));
    // Use download attribute to set desired file name
    a.setAttribute("download", fileName);
    // Trigger the download by simulating click
    a.click();
    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
};
/**
 * Log a message to Sentry.
 *
 * @param message
 * @param params
 * @param level
 */
const log = (message, params, level = 'debug') => {
    if (typeof window.Sentry === 'object') {
        window.Sentry.captureEvent({
            message: { message, params, },
            level
        });
    }
    else {
        console.debug(message, params);
    }
};
/**
 * Generates a non-secure random string.
 * https://stackoverflow.com/questions/1349404/generate-random-string-characters-in-javascript
 * @param length
 */
const randomString = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};
function listOptionsFromEnum(enumObject, pretty = true) {
    const list = [];
    for (let i in enumObject) {
        const label = enumObject[i].replace('_', ' ');
        list.push({
            value: enumObject[i],
            label: pretty ? titleCase(label) : label
        });
    }
    return list;
}
function isEmpty(str) {
    return !str || String(str).length === 0;
}
function hasErrors(errors, keys = null) {
    let filteredErrors = undefined;
    if (keys && errors) {
        filteredErrors = {};
        keys.forEach(key => {
            if (errors[key] && filteredErrors) {
                filteredErrors[key] = errors[key];
            }
        });
    }
    const returnableErrors = filteredErrors ?? errors;
    return returnableErrors && Object.keys(returnableErrors).length > 0;
}
function firstError(errors, keys) {
    if (!errors) {
        return null;
    }
    for (const key of keys) {
        if (errors[key] && Array.isArray(errors[key])) {
            return errors[key][0];
        }
    }
    return null;
}
export { reportApiError, printElementViaCanvas, setUtilsBaseUrl, openInNewTab, buildUrl, printElement, reload, goTo, navigateTo, getQueryVariable, routeIs, figureCloakingIsNotActive, figureCloakingIsActive, jobCloakingIsNotActive, jobCloakingIsActive, shouldShowFundingMarkers, shouldShowInvoiceNotes, fileDownload, log, randomString, listOptionsFromEnum, userCan, isEmpty, firstError, hasErrors, };
